import React from "react";
import cx from "classnames";
import s from "./checkbox.scss";

export default class Checkbox extends React.Component {
  inputRef = React.createRef(null);

  updateValue(e) {
    this.props.onChange({ [this.props.name]: e.currentTarget.checked });
  }

  render() {
    const {
      className,
      name,
      value,
      checked,
      errors,
      disabled,
      hint,
      indeterminate,
      labelFontSizeRegular = false,
      isVianova,
    } = this.props;
    let label = this.props.label;
    // if it is an hidden input, hide the label
    if (this.props.type === "hidden") {
      label = "";
    }

    return (
      <div
        className={cx(className, s.checkboxInput, {
          [s.withErrors]: errors,
          [s.disabled]: disabled,
          [s.indeterminate]: indeterminate,
          [s.vianovaCheckbox]: isVianova,
        })}
      >
        <input
          ref={this.inputRef}
          className={s.checkbox}
          type="checkbox"
          name={name}
          value={value}
          checked={checked}
          disabled={disabled}
          onChange={this.updateValue.bind(this)}
        />

        <div className="flex flex-col">
          <label className={cx(s.label, { [s.fontRegular]: labelFontSizeRegular })} htmlFor={this.props.name}>
            {label || name.replace(/_/g, " ")}
          </label>

          {hint && <div className="text-xs">{hint}</div>}
        </div>

        {errors}
      </div>
    );
  }
}
